import React from "react";
import styled from "styled-components";
import { FaLinkedin, FaTwitter, FaInstagram, FaPhone } from "react-icons/fa";
import Footer from "./components/footer.jsx";
import NavBar from "./components/navbar.jsx";
import LogoWall from "./components/logowall.jsx";
import { Colors } from "./components/colors.jsx";
import { mobileWidth } from "./components/constants.jsx";
import { useTranslation } from "react-i18next";
const EmployersPage = () => {
  const { t, i18n } = useTranslation();
  return (
    <div dir={i18n.dir()}>
      <NavBar />
      <EmployersContainer>
        <Offerings>
          <TopOfferings>
            <Offering
              style={{
                backgroundImage: `url('/static/images/orange5.jpg')`,
              }}
            >
              <OfferingContent>
                <OfferingTitle>{t("offering_work")}</OfferingTitle>
                <OfferingDescription>
                {t("offering_work_desc")}
                </OfferingDescription>
                <FlexRow>
                <Button>{t("touch_button")}</Button>
                <SocialIcons>
                  <SocialIconLink href="https://www.linkedin.com/company/ratib/" target="_blank">
                    <FaLinkedin />
                  </SocialIconLink>
                  <SocialIconLink href="https://twitter.com/RatibKSA" target="_blank">
                    <FaTwitter />
                  </SocialIconLink>
                  <SocialIconLink href="https://www.instagram.com/ratibksa/" target="_blank">
                    <FaInstagram />
                  </SocialIconLink>
                  <SocialIconLink href="tel:+11234567890" target="_blank">
                    <FaPhone />
                  </SocialIconLink>
                </SocialIcons>
                </FlexRow>
              </OfferingContent>
            </Offering>
            <Offering
              style={{ backgroundImage: `url('/static/images/orange4.jpg')` }}
            >
              <OfferingContent>
                <OfferingTitle>{t("offering_hire")}</OfferingTitle>
                <OfferingDescription>
                {t("offering_hire_desc")}
                </OfferingDescription>
              </OfferingContent>
            </Offering>
          </TopOfferings>
          <BottomOfferings>
            <Offering
              style={{ backgroundImage: `url('/static/images/orange9.jpg')` }}
              >
              <OfferingContent>
                <OfferingTitle>{t("offering_150000")}</OfferingTitle>
                <OfferingDescription>
                {t("offering_150000_desc")}
                </OfferingDescription>
              </OfferingContent>
            </Offering>
            <Offering
              style={{ backgroundImage: `url('/static/images/orange7.jpg')` }}
            >
              <OfferingContent>
                <OfferingTitle>{t("offering_7000")}</OfferingTitle>
                <OfferingDescription>
                {t("offering_7000_desc")}
                </OfferingDescription>
              </OfferingContent>
            </Offering>
            <Offering
              style={{ backgroundImage: `url('/static/images/insights.svg')` }}
            >
              <OfferingContent>
                <OfferingTitle>{t("offering_contact")}</OfferingTitle>
                <OfferingDescription>
                {t("offering_contact_desc")}
                </OfferingDescription>
              </OfferingContent>
            </Offering>
          </BottomOfferings>
        </Offerings>
      </EmployersContainer>
      <LogoWall />
      <Footer />
    </div>
  );
};


const EmployersContainer = styled.div`
  margin: 0 auto;
  padding: 40px;
  max-width: 90%;
  margin-top:50px;
`;

const Offerings = styled.div`
  display: flex;
  flex-direction: column;
`;
const FlexRow = styled.div`
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  align-items:center;
`
const TopOfferings = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  @media (max-width: ${mobileWidth}){
    flex-direction: column;
  }
`;

const BottomOfferings = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  flex-wrap: wrap;
  @media (max-width: ${mobileWidth}){
    flex-direction: column;
  }
`;
const Offering = styled.div`
  flex: 1;
  position: relative;
  background-color: #fff;
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  /* Add a semi-transparent overlay */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4); /* Dark overlay with 40% opacity */
    z-index: 1; /* Ensure it appears behind the content */
  }
`;

const OfferingContent = styled.div`
  position: relative; /* Ensure content is above the overlay */
  z-index: 2; /* Place above the overlay */
  display: flex;
  flex-direction: column;
`;

const OfferingTitle = styled.h2`
  font-size: 38px;
  font-weight: bold;
  color: #ffffff; /* Set text color to white for visibility */
  margin-bottom: 10px;
  text-align: center;
`;

const OfferingDescription = styled.p`
  white-space: pre-line;
  font-size: 18px;
  color: #e0e0e0; /* Light gray for contrast */
  line-height: 1.5;
`;

const Button = styled.button`
  padding: 12px 5px;
  border: none;
  border-radius: 20px;
  background-color: #000000;
  color: white;
  font-size: 16px;
  width: 150px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-top: 10px;
  max-width:40%;
`;
const SocialIcons = styled.div`
  display: flex;
  align-items: center;
  height:fit-content;
`;

const SocialIconLink = styled.a`
  color: #333;
  font-size: 20px;
  margin-left: 10px;
  transition: color 0.3s ease; /* Add transition for smooth color change */

  &:hover {
    color: #ff4500; /* Change color on hover */
  }
`;

export default EmployersPage;